// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ph8qqMDhIqEd9Q7efIjE{grid-template-columns:auto 1fr;align-items:center;gap:12px;min-height:56px;display:grid}.nutlL5q9FB46C0bso50r{min-width:0;color:var(--content-primary-primary);flex-direction:column;gap:4px;display:flex}.boIJ_PCGTbQvifvbgTiz{align-items:center;gap:4px;display:flex}.e1KXFk5GUAe0Tw2JNFx2{align-items:center;gap:8px;display:flex}.e1KXFk5GUAe0Tw2JNFx2>:first-child{flex:1;min-width:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"account": `ph8qqMDhIqEd9Q7efIjE`,
	"content": `nutlL5q9FB46C0bso50r`,
	"accountName": `boIJ_PCGTbQvifvbgTiz`,
	"mapping": `e1KXFk5GUAe0Tw2JNFx2`
};
export default ___CSS_LOADER_EXPORT___;
